import React, { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

// "Install as app": Android/desktop via beforeinstallprompt; iOS gets the Share → Add to Home Screen hint.
export function InstallAppButton({ className = "" }) {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const [hint, setHint] = useState(false);
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    setIos(/iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (standalone || (!evt && !ios)) return null;
  const go = async () => { if (evt) { evt.prompt(); await evt.userChoice; setEvt(null); } else setHint((h) => !h); };
  return (
    <div className="relative">
      <button data-testid="install-app-btn" onClick={go} className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg px-2.5 py-1.5 bg-white/15 border border-white/25 text-white hover:bg-white/25 ${className}`}>
        <Download size={13} /> Install app
      </button>
      {hint && <div data-testid="install-ios-hint" className="absolute right-0 mt-1 w-64 bg-white text-[#1A1A2E] rounded-xl shadow-xl border border-[#EEE4DA] p-3 text-xs z-50">
        On iPhone/iPad: tap <Share size={12} className="inline" /> <b>Share</b> in Safari, then <b>Add to Home Screen</b>. Rankers OS opens like an app.</div>}
    </div>
  );
}
